// extracted by mini-css-extract-plugin
module.exports = {"SaveFormModalText":"useSaveUnsavedChangesInForm_SaveFormModalText__3E48V","SaveFormModalButtonContainer":"useSaveUnsavedChangesInForm_SaveFormModalButtonContainer__1d1L4"};